import { useReducer, useCallback } from 'react'

interface AddressState {
  isInitialized: boolean
  originalValues: {
    province: string | null
    city: string | null
    cityId: string | null
    postalCode: string | null
  }
}

type AddressAction =
  | {
      type: 'INITIALIZE'
      payload: { province: string; city: string; cityId: string; postalCode: string }
    }
  | { type: 'RESET' }

const initialState: AddressState = {
  isInitialized: false,
  originalValues: {
    province: null,
    city: null,
    cityId: null,
    postalCode: null,
  },
}

const addressReducer = (state: AddressState, action: AddressAction): AddressState => {
  switch (action.type) {
    case 'INITIALIZE':
      return {
        isInitialized: true,
        originalValues: {
          province: action.payload.province,
          city: action.payload.city,
          cityId: action.payload.cityId,
          postalCode: action.payload.postalCode,
        },
      }
    case 'RESET':
      return initialState
    default:
      return state
  }
}

export const useAddressState = () => {
  const [state, dispatch] = useReducer(addressReducer, initialState)

  const initializeOriginalValues = useCallback(
    (values: { province: string; city: string; cityId: string; postalCode: string }) => {
      dispatch({ type: 'INITIALIZE', payload: values })
    },
    [],
  )

  const resetState = useCallback(() => {
    dispatch({ type: 'RESET' })
  }, [])

  return {
    ...state,
    initializeOriginalValues,
    resetState,
  }
}